import { FC, ReactNode } from 'react';
import { FormProvider } from 'react-hook-form';
import { useRealEstatePropertyForm } from '../hooks';
import { RealEstateFormContextProvider } from '../context';

interface RealEstatePropertyFormProps {
  children?: ReactNode;
  className?: HTMLFormElement['className'];
  useRealEstateFormReturn: ReturnType<typeof useRealEstatePropertyForm>;
}

/**
 * 
 * @deprecated Use ElementsForm from packages/elements/src/UI/components/ElementsForm.tsx in combination with
 * useCreateRealEstateForm from  packages/elements/src/RealEstateProperty/hooks/useCreateRealEstateForm.ts
 * and useEditRealEstateForm from  packages/elements/src/RealEstateProperty/hooks/useEditRealEstateForm.ts
 * instead
 */
export const RealEstatePropertyForm: FC<RealEstatePropertyFormProps> = ({
  children,
  className,
  useRealEstateFormReturn: { formMethods, onSubmit, householdID, realEstateProperty },
}) => {
  return (
    <RealEstateFormContextProvider realEstate={realEstateProperty} householdID={householdID}>
      <FormProvider {...formMethods}>
        <form className={className} onSubmit={formMethods.handleSubmit(onSubmit)}>
          {children}
        </form>
      </FormProvider>
    </RealEstateFormContextProvider>
  );
};
